<template>
  <div class="m-5">
    <div class="flex justify-between items-center pb-5">
      <h2 v-if="hasRole('Consultant')" class=" text-primary-500 mb-0">
        My Communities/Groups
      </h2>
      <h2 v-else>
        My Mentees/Groups
      </h2>
    </div>
    <d-tabs v-model="activeTab">
      <d-tab-item v-if="hasRole('Mentor')" label="Mentees">
        <mentor-mentees-page />
      </d-tab-item>
      <d-tab-item v-if="hasRole('Consultant')" label="Communities">
        <communities-page />
      </d-tab-item>
      <d-tab-item label="Groups">
        <mentor-groups-page />
      </d-tab-item>
    </d-tabs>
  </div>
</template>

<script>
  export default {
    name: 'MentorTabbedPage',
  };
</script>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import axios from 'axios';

  export default {
    parent: true,
    props: {

    },

    computed: {
      ...mapGetters('d2Auth', ['hasRole']),
    },

    data: () => ({
      activeTab: 0,
    }),

    mounted() {
    },

    methods: {

    },
  };
</script>